export async function getCsrfToken() {
  try {
    const response = await fetch('/api/get-csrf-token/', {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
      }
    });
    
    if (!response.ok) {
      console.error('Failed to fetch CSRF token, status:', response.status);
      throw new Error('Failed to fetch CSRF token');
    }
    
    const data = await response.json();
    
    document.cookie = `csrftoken=${data.csrf_token}; path=/; SameSite=Strict`;
    return data.csrf_token;
  } catch (error) {
    console.error('Error getting CSRF token:', error);
    
    // Fallback: try to get token from cookie
    const storedToken = getStoredCsrfToken();
    if (storedToken) {
      return storedToken;
    }
    
    throw error;
  }
}

export function getStoredCsrfToken() {
  const token = document.cookie.split('; ')
    .find(row => row.startsWith('csrftoken='))
    ?.split('=')[1];
  return token;
}